import React, { useEffect, useState, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { FeaturesSection } from './components/FeaturesSection';
import { LocationSection } from './components/LocationSection';
import { UnitsSection } from './components/UnitsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { GalleryPage } from './pages/GalleryPage';
import { UnitsPage } from './pages/UnitsPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  // Google Analytics (gtag.js)
  useEffect(() => {
    // Initialize dataLayer
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () {
      w.dataLayer.push(arguments);
    };
    w.gtag('js', new Date());
    w.gtag('config', 'G-X0FP2EDPSF');
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-X0FP2EDPSF';
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Route to AboutPage
  if (currentPath.startsWith('#o-projektu-stranka')) {
    return <AboutPage data-id="element-0" />;
  }
  // Route to GalleryPage
  if (currentPath.startsWith('#cela-galerie')) {
    return <GalleryPage data-id="element-1" />;
  }
  // Route to UnitsPage
  if (currentPath.startsWith('#nabidka-bytu')) {
    return <UnitsPage data-id="element-2" />;
  }
  return <div className="min-h-screen bg-base-cream font-body text-base-dark" data-id="element-3">
      <Navbar data-id="element-4" />
      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <AboutSection data-id="element-7" />
        <GallerySection data-id="element-8" />
        <FeaturesSection data-id="element-9" />
        <LocationSection data-id="element-10" />
        <UnitsSection data-id="element-11" />
        <ContactSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}